<app-basic-layout>

    <!-- form components start -->
    <div class="form-components">

        <div class="form-components__title"><h2>{{ $t('Verify Email') }}</h2></div>
        <div class="form-components__body">
            <form @submit.prevent="submit">
                <div class="form-components__input-text">
                    <div class="form-components__block">
                        <div class="form-components__block-item block-text">
                            <p>
                                {{ $t("Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you didn't receive the email, we will gladly send you another.") }}
                            </p>
                            <p v-if="verificationLinkSent" class="form-success__text">
                                {{ $t('A new verification link has been sent to the email address you provided during registration.') }}
                            </p>
                        </div>
                    </div>
                    <div class="form-components__block">
                        <div class="form-components__block-item block-button">
                            <button type="submit" :class="{ 'opacity-75': form.processing }" :disabled="form.processing" class="form-components__block-button">
                                <svg v-show="form.processing" class="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                                {{ $t('Resend Verification Email') }}
                            </button>
                        </div>
                    </div>
                    <div class="form-components__block">
                        <inertia-link :href="route('logout')" method="post" as="a" class="form-components__block-link">{{ $t('Logout') }}</inertia-link>
                    </div>
                </div>
            </form>
        </div>
    </div>
</app-basic-layout>
